"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var common_1 = require("stremio/common");
var core_1 = require("stremio/core");
var nextRequestId = 0;
var localServerUrl = function (value) {
    try {
        var url = new URL(value !== null && value !== void 0 ? value : '');
        if (!['http:', 'https:'].includes(url.protocol) || !['localhost', '127.0.0.1', '[::1]'].includes(url.hostname)) {
            return null;
        }
        url.hostname = '127.0.0.1';
        return url.href;
    }
    catch (_a) {
        return null;
    }
};
var useCacheLocation = function (streamingServer) {
    var _a, _b, _c, _d;
    var core = (0, core_1.useCore)();
    var _e = (0, common_1.usePlatform)(), shell = _e.shell, name = _e.name;
    var t = (0, react_i18next_1.useTranslation)().t;
    var request = (0, react_1.useRef)(null);
    var _f = (0, react_1.useState)(false), choosing = _f[0], setChoosing = _f[1];
    var _g = (0, react_1.useState)(null), pickerError = _g[0], setPickerError = _g[1];
    var transportUrl = (_a = streamingServer.selected) === null || _a === void 0 ? void 0 : _a.transportUrl;
    var settings = ((_b = streamingServer.settings) === null || _b === void 0 ? void 0 : _b.type) === 'Ready' ? streamingServer.settings.content : null;
    var option = (_c = streamingServer.settingsOptions) === null || _c === void 0 ? void 0 : _c.find(function (_a) {
        var id = _a.id;
        return id === 'cacheRoot';
    });
    var selections = (_d = option === null || option === void 0 ? void 0 : option.selections) !== null && _d !== void 0 ? _d : [];
    var update = streamingServer.cacheRootUpdate;
    var busy = (update === null || update === void 0 ? void 0 : update.type) === 'Loading';
    var localUrl = localServerUrl(transportUrl);
    var supported = ['macos', 'windows'].includes(name) && shell.capabilities.cacheDirectoryPicker &&
        (option === null || option === void 0 ? void 0 : option.supportsDirectory) === true &&
        localUrl !== null && localUrl === localServerUrl(shell.state.streamingServerUrl) &&
        selections.length && settings && update !== undefined;
    (0, react_1.useEffect)(function () {
        var onSelected = function (_a) {
            var _b;
            var requestId = _a.requestId, path = _a.path, error = _a.error;
            if (((_b = request.current) === null || _b === void 0 ? void 0 : _b.id) !== requestId)
                return;
            var transportUrl = request.current.transportUrl;
            request.current = null;
            setChoosing(false);
            if (error) {
                setPickerError({ transportUrl: transportUrl, message: error });
            }
            else if (path) {
                core.transport.dispatch({
                    action: 'StreamingServer',
                    args: { action: 'UpdateCacheRoot', args: { transportUrl: transportUrl, cacheRoot: path } }
                });
            }
        };
        shell.on('cache-directory-selected', onSelected);
        return function () {
            shell.off('cache-directory-selected', onSelected);
            request.current = null;
        };
    }, [core, shell.on, shell.off]);
    var onSelect = function (value) {
        if (!supported || !transportUrl || busy || choosing)
            return;
        setPickerError(null);
        if (value === 'choose') {
            var id = ++nextRequestId;
            request.current = { id: id, transportUrl: transportUrl };
            setChoosing(true);
            shell.send('pick-cache-directory', {
                requestId: id, serverUrl: shell.state.streamingServerUrl, directory: settings.cacheRoot,
            });
        }
        else if (value !== settings.cacheRoot) {
            core.transport.dispatch({
                action: 'StreamingServer',
                args: { action: 'UpdateCacheRoot', args: { transportUrl: transportUrl, cacheRoot: value } }
            });
        }
    };
    return {
        busy: busy,
        error: supported && (pickerError && pickerError.transportUrl === transportUrl ? pickerError.message :
            (update === null || update === void 0 ? void 0 : update.type) === 'Err' ? t('GENERIC_ERROR_MESSAGE') : null),
        select: supported ? {
            options: __spreadArray(__spreadArray([], selections.filter(function (_a) {
                var val = _a.val;
                return typeof val === 'string';
            })
                .map(function (_a) {
                var name = _a.name, val = _a.val;
                return ({ label: name, value: val });
            }), true), [
                { label: "".concat(t('SELECT'), "\u2026"), value: 'choose' },
            ], false),
            value: settings.cacheRoot,
            title: settings.cacheRoot,
            disabled: busy || choosing,
            onSelect: onSelect,
        } : null,
    };
};
exports.default = useCacheLocation;
